import {
  IFormInformation,
  IReassignmentDTO,
} from '../../../../interfaces/interfaceReassignment';
import { getActionsTemplate } from './BodyTemplatesTable';

export const torniqueteVRTGaritaPOSCAU: IFormInformation[] = [
  {
    label: 'Estación',
    key: 'StationName',
    name: 'stationId',
    optionLabel: 'StationName',
    optionValue: 'StationId',
    options: 'stations',
    disabled: false,
    disabledValue: '',
  },
  {
    label: 'Location Id',
    key: 'LocationName',
    name: 'locationId',
    optionLabel: 'LocationName',
    optionValue: 'LocationId',
    options: 'locations',
    disabled: true,
    disabledValue: 'stationId',
  },
  {
    label: 'Proyecto',
    key: 'ProjectName',
    name: 'projectId',
    optionLabel: 'ProjectName',
    optionValue: 'ProjectId',
    options: 'projects',
    disabled: true,
    disabledValue: 'locationId',
  },
  {
    label: 'Id Lector',
    key: 'DeviceNumber',
    name: 'DeviceId',
    optionLabel: 'DeviceNumber',
    optionValue: 'DeviceId',
    options: 'readersIds',
    disabled: true,
    disabledValue: 'locationId',
  },
];

export const cetSac: IFormInformation[] = [
  {
    label: 'Nombre Ruta',
    key: 'RouteName',
    name: 'routeId',
    optionLabel: 'RouteName',
    optionValue: 'RouteId',
    options: 'routes',
    disabled: false,
    disabledValue: '',
  },
  {
    label: 'Número Económico',
    key: 'EconomicNumber',
    name: 'economicNumberId',
    optionLabel: 'EconomicNumber',
    optionValue: 'EconomicNumberId',
    options: 'economicNumbers',
    disabled: false,
    disabledValue: '',
  },
  {
    label: 'Id Lector',
    key: 'DeviceNumber',
    name: 'DeviceId',
    optionLabel: 'DeviceNumber',
    optionValue: 'DeviceId',
    disabled: false,
    disabledValue: '',
    options: 'readersIds',
  },
];

export const samFarm: IFormInformation[] = [
  {
    label: 'Proyecto',
    key: 'ProjectName',
    name: 'projectId',
    optionLabel: 'ProjectName',
    optionValue: 'ProjectId',
    options: 'projects',
    disabled: false,
    disabledValue: '',
  },
  {
    label: 'Id de Socket',
    key: 'SocketId',
    name: 'socketId',
    optionLabel: 'SocketId',
    optionValue: 'SocketId',
    options: 'socket',
    disabled: false,
    disabledValue: '',
  },
  {
    label: 'Id Lector',
    key: 'DeviceNumber',
    name: 'DeviceId',
    optionLabel: 'DeviceNumber',
    optionValue: 'DeviceId',
    options: 'readersIds',
    disabled: false,
    disabledValue: '',
  },
];
